import { Component, inject } from '@angular/core';
import { NgIcon, provideIcons, provideNgIconLoader, withCaching } from '@ng-icons/core';

import { HttpClient } from "@angular/common/http";
import { MatButton } from "@angular/material/button";
import { Router } from "@angular/router";
import { heroXMark } from "@ng-icons/heroicons/outline";
import { routePath } from "app/shared/app.config";

@Component({
  selector: 'app-guest-header',
  standalone: true,
  imports: [MatButton, NgIcon],
  templateUrl: './guest-header.component.html',
  styleUrls: ['./guest-header.component.scss'],
  providers: [
    provideIcons({ heroXMark }),
    provideNgIconLoader((name) => {
      const http = inject(HttpClient);
      return http.get(`/assets/icons/${name}.svg`, { responseType: 'text' });
    }, withCaching()),
  ],
})
export class GuestHeaderComponent {
  router = inject(Router);

  onCreateAccount() {
    this.router.navigate([`/${routePath.signUp}`]);
  }
}
